<template>
    <div class="help-center-main-body">
        <help-center-tabs
            :selected-help-center-tab="selectedHelpCenterTab"
            @onTabClick="scrollToCategory"
        />

        <div v-if="helpCenterContent" class="help-center-center-content">
            <div ref="helpContainer" class="section-container">
                <div id="help_center_tutorials" class="section">
                    <h5 class="section-heading">
                        {{ $translate('tutorials') }}
                    </h5>

                    <div class="section-card-container">
                        <help-center-video-preview
                            v-for="video in helpCenterContent.videos"
                            :key="video._id"
                            :video="video"
                            class="section-card"
                        />
                    </div>
                </div>

                <div id="help_center_manuals" class="section">
                    <h5 class="section-heading">
                        {{ $translate('manuals') }}
                    </h5>

                    <div class="section-card-container">
                        <help-center-manual
                            v-for="manual in helpCenterContent.manuals"
                            :key="manual._id"
                            :manual="manual"
                        />
                    </div>
                </div>

                <div id="help_center_faqs" class="section">
                    <h5 class="section-heading">
                        {{ $translate('faqs') }}
                    </h5>

                    <div class="section-faq-container">
                        <help-center-faq
                            v-for="faq in helpCenterContent.faqs"
                            :key="faq._id"
                            :faq="faq"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import UIUtils from '../../../business/utils/UIUtils'
import HelpCenterVideoPreview from './partials/HelpCenterVideoPreview'
import HelpCenterManual from './partials/HelpCenterManual'
import HelpCenterFaq from './partials/HelpCenterFaq'
import HelpCenterTabs from './partials/HelpCenterTabs'

export default {
    name: 'HelpCenterMainBody',
    components: {
        HelpCenterVideoPreview,
        HelpCenterManual,
        HelpCenterFaq,
        HelpCenterTabs
    },
    data() {
        return {
            selectedHelpCenterTab: 'tutorials'
        }
    },
    computed: {
        ...mapState({
            helpCenterContent: state => state.onboarding.helpCenterContent
        })
    },
    mounted() {
        UIUtils.hideLoadingMask()
        this.$refs.helpContainer.addEventListener('scroll', this.keepTabUpdated)

    },
    beforeDestroy() {
        this.$refs.helpContainer.removeEventListener('scroll', this.keepTabUpdated)
    },
    methods: {
        scrollToCategory(category) {
            this.selectedHelpCenterTab = category
            const el = document.getElementById(`help_center_${category}`)
            const section = this.$refs.helpContainer
            section.scrollTo({ top: el.offsetTop - section.offsetTop, behavior: 'smooth' })
        },
        keepTabUpdated(event) {
            const { target } = event
            let category = this.selectedHelpCenterTab
            for (const targetElement of target.children) {
                if (targetElement.offsetTop - target.offsetTop - target.scrollTop < 1) {
                    category = targetElement.id.split('help_center_')[1]
                }
            }
            this.selectedHelpCenterTab = category
        }
    }
}
</script>

<style lang="scss" scoped>
.help-center-main-body {
    max-width: 1344px;
    margin: 0 auto;

    .help-center-center-content {
        height: calc(100vh - var(--header-height) - var(--sub-header-height) - 2rem);
    }

    .section-container {
        overflow-x: auto;
        height: 100%;
        max-height: 100%;
        width: 100%;
        padding: 0 1rem;
        @include hide-scrollbar();

        .section {
            margin: 3rem 0;

            .section-heading {
                text-transform: capitalize;
                margin-top: 0.5rem;

                @media screen and #{$new-break1} {
                    display: none;
                }
            }

            .section-card-container {
                display: grid;
                gap: 1rem;
                padding-bottom: 1rem;
                padding-top: 1rem;
                width: 100%;

                .section-card {
                    border-radius: 0.2rem;
                    transition: all 0.2s;
                    display: flex;
                    flex-direction: column;

                    &:hover {
                        box-shadow: 4px 4px 20px #000000cc;
                        border-radius: 4px;
                    }
                }

                @media screen and #{$new-break1} {
                    grid-template-columns: 1fr;
                }
                @media screen and #{$new-break2} {
                    grid-template-columns: repeat(2, 1fr);
                }
                @media screen and #{$new-break3} {
                    grid-template-columns: repeat(3, 1fr);
                }
                @media screen and #{$new-break4open} {
                    grid-template-columns: repeat(4, 1fr);
                }
            }

            .section-faq-container {
                @media screen and #{$new-break2open} {
                    background: $dark-3;
                    padding: 4rem 3rem;
                    margin-top: 1rem;
                }
                @media screen and #{$new-break1} {
                    padding-top: 1rem;
                }
            }
        }
    }
}
</style>